import VideoPreview, { extractYouTubeId } from './VideoPreview';

export { extractYouTubeId };
export default VideoPreview;
